import React, { useEffect, useState } from 'react';
import DataTableReact from '../../components/common/datatable/DataTableReact';
import { RightArrow, Dots } from '../../assets/svg.js';
import addline from '../../assets/icons/add-line.svg';
import NewRequest from '../../components/common/newRequest/NewRequest.jsx';
import RequestDetail from '../../components/common/requestDetail/RequestDetail.jsx';
import apiService from '../../services/apiService.js';
import time from '../../assets/icons/time-fill.svg';
import Accepted from '../../assets/icons/check-double-fill.svg';
import Closed from '../../assets/icons/select-box-circle-fill (3).svg';
import Rejected from '../../assets/icons/close-circle-fill.svg';
import Approved from '../../assets/icons/megaphone.svg';
import Announcement from '../../components/common/announcementModal/Announcement.jsx';
import Partially from '../../assets/icons/circle-half.svg';
import useMedicalSpecialties from 'components/common/medSpecialty/MedicalSpecialty.jsx';
import debounce from 'lodash.debounce';
import CustomDropDown from '../../components/common/dropdown/Dropdown.jsx';

const actionStatuses = [
  { value: 'Approved', label: 'Approved' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Rejected', label: 'Rejected' },
];
const Listing = () => {
  const [requestList, setRequestList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalStepper, setIsModalStepper] = useState(false);
  const [isAnnounce, setIsAnnounce] = useState(false);
  const [detailData, setDetailData] = useState();
  const [rowData, setRowData] = useState(null);
  const [id, setId] = useState(null);
  const [Pagination, setPaginaton] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [prevPageUrl, setPrevPageUrl] = useState(null);
  const [nextPageUrl, setNextPageUrl] = useState(null);
  const [loading, setloading] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));

  const [filters, setFilters] = useState({
    job_number: '',
    created_at: '',
    medicalSpecialties: [],
    actionStatus: '',
  });

  const handleClick = () => {
    // Show the modal
    setIsModalOpen(true);
  };

  const handleClose = () => {
    // Hide the modal
    setIsModalOpen(false);
  };

  const detailForm = async (data) => {
    try {
      const response = await apiService.get(`job-requests/${data?._id}`);
      if (response?.data) {
        setDetailData(response?.data);
      } else {
        response?.data('');
      }
    } catch (e) {
      console.log('Error fetching users:', e);
    }
    setIsModalStepper(true);
  };

  const renderRowActions = ({ row, table }) => (
    <RightArrow
      className="action-icon"
      onClick={() => detailForm(row?.original)}
    />
  );

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const columns = [
    {
      id: 'Req #',
      header: 'Req #',
      accessorKey: 'reqNumber', // Accessing 'reqNumber' field in the data
      Cell: ({ row }) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.original?.requestNumber || '-'}
          </span>
        );
      },
    },
    {
      id: 'Practitioners Specialty',
      header: 'Practitioners Specialty',
      accessorKey: 'specialties', // Accessing 'specialties' field in the data
      muiTableHeadCellProps: {
        sx: (theme) => {
          return {
            display: 'flex',
            width: '350px',
            padding: '8px 12px 8px 12px',
            'align-items': 'center',
            gap: '10px',
            color: '#525866',
            'font-feature-settings':
              "'ss11' on, 'cv09' on, 'liga' off, 'calt' off",
            'font-family': 'Inter',
            'font-size': '14px',
            'font-style': 'normal',
            'font-weight': '400',
            'line-height': '20px' /* 142.857% */,
            'letter-spacing': '-0.084px',
            'background-color': '#F6F8FA !important',
            border: 'none',
          };
        },
      },
      muiTableBodyCellProps: {
        sx: {
          display: 'flex',
          width: '350px',
          height: '48px',
          padding: '12px 20px 12px 12px',
          'align-items': 'center',
          gap: '12px',
          // "background-color": "red",
        },
      },
      Cell: ({ row }) => {
        const specialties = row?.original?.job_positions || [];
        const maxVisible = 2; // Number of specialties to display initially

        function getColorClass(index) {
          switch (index) {
            case 0:
              return 'bg-[#EEEBFF] text-[#2B1664]'; // First item's color
            case 1:
              return 'bg-[#FFF3E8] text-[#8D4D00]'; // Second item's color
            default:
              return 'bg-[#F0F0F0] text-[#333333]'; // Default color for the rest
          }
        }

        return (
          <div className={`flex gap-2`}>
            {specialties.slice(0, maxVisible).map((position, index) => (
              <span
                key={index}
                className={`flex slef-center items-center justify-center px-2 py-0.5 rounded-full  text-center font-inter text-xs font-medium leading-[16px] ${getColorClass(
                  index
                )}`}
              >
                {position?.medical_speciality?.name}
              </span>
            ))}
            {specialties.length > maxVisible && (
              <span className="bg-[#F5F5F5] text-[#666666] flex slef-center items-center justify-center px-1.5 py-0.5 rounded-full  text-center font-inter text-xs font-medium leading-[16px]">
                {`+${specialties.length - maxVisible}`}
              </span>
            )}
          </div>
        );
      },
    },
    {
      id: 'Hospital',
      header: 'Hospital',
      Cell: ({ row }) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.original?.creator?.firstName || '-'}
          </span>
        );
      },
    },
    {
      id: 'Total No',
      header: 'Total No',
      accessorKey: 'totalNo', // Accessing 'totalNo' field in the data
      Cell: ({ row }) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {`${row?.original?.job_positions.length}`.length < 2
              ? `0${row?.original?.job_positions?.length}`
              : row?.original?.job_positions?.length || '-'}
          </span>
        );
      },
    },
    {
      id: 'Date of Request',
      header: 'Date of Request',
      accessorKey: 'dateOfRequest', // Accessing 'dateOfRequest' field in the data
      Cell: ({ row }) => {
        function formatDate(dateString) {
          const date = new Date(dateString); // Parse the input date string
          const options = { day: '2-digit', month: 'short', year: 'numeric' };
          return new Intl.DateTimeFormat('en-US', options).format(date);
        }
        const formattedDate = formatDate(row?.original?.created_at);
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {formattedDate || '-'}
          </span>
        );
      },
    },
    {
      header: 'Status',
      accessorKey: 'status', // Accessing 'status' field in the data
      Cell: ({ row }) => {
        let statusToReturn = {
          under_review: {
            icon: time,
            text: 'Pending',
          },
          accepted: {
            icon: Accepted,
            text: 'Accepted',
          },
          approved: {
            icon: Approved,
            text: 'Approved',
          },
          partially_approved: {
            icon: Partially,
            text: 'Partially Approved',
          },
          closed: {
            icon: Closed,
            text: 'Closed',
          },
          rejected: {
            icon: Rejected,
            text: 'Rejected',
          },
        };
        return (
          <span className="flex justify-center px-[6px] py-[4px] items-center gap-[4px] rounded-md border border-[#E2E4E9] bg-white text-[#525866] font-inter text-xs font-medium leading-4 tracking-[0.02em]">
            {statusToReturn[row?.original?.status]?.icon && (
              <img
                src={statusToReturn[row?.original?.status]?.icon}
                alt="status"
                className="w-[16px] h-[16px]"
              />
            )}{' '}
            <p className="m-0 self-center">
              {statusToReturn[row?.original?.status]?.text}
            </p>
          </span>
        );
      },
    },
  ];

  const handleAnnounceClick = (row, id) => {
    setIsModalStepper(false);
    setRowData(
      row?.job_positions && row.job_positions !== '' ? row.job_positions : row
    );
    setId(id);
    setIsAnnounce(true);
  };

  const fetchRequests = async (updatedFilters, page, rowsPerPage) => {
    try {
      setloading(true);
      const perPage = rowsPerPage !== undefined ? rowsPerPage : 10;
      const currentPage = page !== undefined ? page : 1;
      const payload = {
        job_number: String(updatedFilters?.job_number || ''),
        created_at: String(updatedFilters?.created_at || ''),
        medical_speciality: String(
          updatedFilters?.medicalSpecialties
            ?.map((label) => label?.label)
            .join(', ') || ''
        ),
        actionStatus: String(updatedFilters?.actionStatus || '').toLowerCase(),
      };
      const response = await apiService.get(
        `job-requests?is_pagination=true&per_page=${perPage}&page=${currentPage}`,
        payload
      );
      if (response?.code === 200) {
        setRequestList(response?.data?.data || []);

        setTotalRows(response?.data?.total);

        setloading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const init = () => {
    fetchRequests(filters, page, rowsPerPage);
  };

  const handleDebouncedChange = debounce(
    (updatedFilters, page, rowsPerPage) => {
      setloading(true);

      const payload = {
        job_number: String(updatedFilters.job_number || ''),
        created_at: String(updatedFilters?.created_at || ''),
        medical_speciality: String(
          updatedFilters.medicalSpecialties
            ?.map((label) => label?.label)
            .join(', ') || ''
        ),
        actionStatus: String(updatedFilters.actionStatus || '').toLowerCase(),
      };

      // Use apiService to send the API request
      apiService
        .get(`job-requests?is_pagination=true&per_page=${rowsPerPage}`, payload)
        .then((response) => {
          setTotalRows(response?.data?.total);

          setloading(false);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    },
    500
  );

  // Update filters and trigger debounced change
  const handleInputChange = (e) => {
    let value;
    let name;

    if (e !== null && e.target) {
      // Standard input or select elementt
      const { name: inputName, value: inputValue } = e.target;
      name = inputName;
      value = inputValue;
    } else {
      // Custom component like react-select
      name = 'actionStatus'; // Assuming custom component passes 'name'
      value = e; // Assuming value is passed in a custom event object
      if (Array.isArray(value)) {
        name = 'medicalSpecialties'; // Assign to medicalSpecialties
        value = value.map((item) => item);
      } else {
        console.log("It's not an array.", value);
      }
    }

    // Handle special case for 'medicalSpecialties' (if it's a comma-separated list)
    const updatedFilters = {
      ...filters,
      [name]:
        name === 'medicalSpecialties'
          ? value?.map(({ label, value }) => ({ label, value })) || []
          : value,
    };
    setFilters(updatedFilters);
    // Trigger the debounced API call
    handleDebouncedChange(updatedFilters, page, rowsPerPage);
  };

  const medSp = useMedicalSpecialties();

  useEffect(() => {
    init(filters, page, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <>
      <div>
        {isAnnounce && (
          <Announcement
            rowData={rowData}
            requestDetails={detailData}
            setIsAnnounce={setIsAnnounce}
            id={id}
            fetchRequests={fetchRequests}
            page={page}
            rowsPerPage={rowsPerPage}
          />
        )}
        {isModalOpen && (
          <NewRequest onClose={handleClose} fetchRequests={fetchRequests} />
        )}

        {isModalStepper && (
          <RequestDetail
            isCluster={user?.role === 'cluster_manager'}
            page={page}
            rowsPerPag={rowsPerPage}
            fetchRequests={fetchRequests}
            init={fetchRequests}
            requestDetails={detailData}
            handleAnnounceClick={handleAnnounceClick}
            onClose={setIsModalStepper}
          />
        )}

        <div className="d-flex justify-content-between align-items-center p-4 bg-gray-100">
          <div className="grid grid-cols-4 gap-4">
            {/* English Name */}
            <input
              type="text"
              name="job_number"
              placeholder="Enter Request Number"
              value={filters.job_number}
              onChange={(e) => {
                handleInputChange(e, page, rowsPerPage); // Update state if input is valid
              }}
              className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring-0 focus:bg-transparent"
            />

            {/* Action Status */}

            <CustomDropDown
              name="medicalSpecialties"
              value={
                filters.medicalSpecialties?.map((site) => ({
                  label: site?.label,
                  value: site?.value,
                })) || []
              }
              onFieldSelect={(e) => {
                handleInputChange(e);
              }}
              options={
                medSp?.map(({ name, _id, ...rest }) => ({
                  label: name,
                  value: _id,
                  ...rest,
                })) || []
              }
              zIndex={'99999'}
              isMulti={true}
            />
            <CustomDropDown
              name="actionStatus"
              value={filters.actionStatus}
              onChange={handleInputChange}
              options={actionStatuses}
              zIndex={'99999'}
            />

            <input
              type="date"
              name="created_at"
              placeholder="Date"
              value={filters.created_at}
              onChange={(e) => {
                handleInputChange(e, page, rowsPerPage); // Update state if input is valid
              }}
              className="px-3 py-[4px] border border-gray-300 rounded-[12px] focus:outline-none focus:ring"
            />
          </div>

          <div className="flex justify-center items-center gap-2">
            <div className="mt-2 pl-2">Total Count:{totalRows}</div>
            {user?.role == 'hospital_manager' && (
              <div className="mt-2 pl-2">
                <button
                  type="button"
                  onClick={() => handleClick()}
                  id="dashboard-tab"
                  data-tabs-target="#dashboard"
                  role="tab"
                  aria-controls="dashboard"
                  class="text-white bg-[#007A63] flex justify-center items-center  focus:ring-4 focus:outline-none w-[180px] h-[50px] font-medium rounded-[12px] text-sm py-2.5 text-center inline-flex items-center"
                >
                  <img src={addline} alt="logo" />
                  New Request
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <DataTableReact
        data={requestList}
        columns={columns}
        renderRowActions={handleRenderRowActions}
        prevPageUrl={prevPageUrl}
        nextPageUrl={nextPageUrl}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        loading={loading}
        Pagination={Pagination}
        totalRows={totalRows}
        shouldShowActions={true}
      />
    </>
  );
};

export default Listing;
